import { Card, Col, Row, Table } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BannerCard from "../../../common/components/BannerCard";
import { asDate } from "../../../common/constants/Helpers";
import { LookupRequest } from "../../../models/lookup-request";
import { buildSummaryRequest, civilRequest } from "../../../state/connect-api";
import { useCivilCaseDocketMutation, useGetCaseDocketMutation } from "../../../state/globalApi";
import { setCivilMaster, updateCaseMaster } from "../../../state/globalStore";
import { RootState } from "../../../store";
import getConfigs from "../../../GetConfigs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const CaseDocket = ({ ...props }) => {
  const { activeCaseNumber, caseMaster, civilMaster } = useSelector((state: RootState) => state.global);
  const dispatch = useDispatch();
  const [getCaseDocket, result] = useGetCaseDocketMutation();
  const [getCivilCaseDocket] = useCivilCaseDocketMutation();


  const configurations = getConfigs([
    "ctDocketRemarks",
    "ctTRCRDocketTxt",
    "ctCVLDocketTxt"
  ]);
  useEffect(() => {
    if (props.civilTab) {
      const lookupRequest: LookupRequest = civilRequest(activeCaseNumber);
      const fetch = async () => {
        const docket = await getCivilCaseDocket(lookupRequest).unwrap();
        dispatch(setCivilMaster({ docket: docket }));
        setMessageVisible(!!configurations.ctCVLDocketTxt);
      };
      fetch();
    } else {
      const lookupRequest = buildSummaryRequest(activeCaseNumber);
      setMessageVisible(!!configurations.ctTRCRDocketTxt);
      const fetch = async () => {
        const docket = await getCaseDocket(lookupRequest).unwrap();
        dispatch(updateCaseMaster({ docket: docket }));
      };
      fetch();
    }
  }, [getCaseDocket, dispatch, activeCaseNumber]);

  const [messageVisible, setMessageVisible] = useState<boolean>(true)

  const columns = [
    { key: "date", title: "Date", dataIndex: "DATE", ...asDate },
    {
      key: configurations.ctDocketRemarks === "Y" || (configurations.ctDocketRemarks === "A" && localStorage.getItem("LOGINTYPE") === "A") ? "remarks" : null,
      title: configurations.ctDocketRemarks === "Y" || (configurations.ctDocketRemarks === "A" && localStorage.getItem("LOGINTYPE") === "A") ? "Remarks" : null,
      dataIndex: configurations.ctDocketRemarks === "Y" || (configurations.ctDocketRemarks === "A" && localStorage.getItem("LOGINTYPE") === "A") ? "REMARKS" : null
    },
    { key: "status", title: "Status", dataIndex: "STATUS" }
  ];

  const civilColumns = [
    { key: "date", title: "Date", dataIndex: "EntryShortDate", ...asDate, width: 120 },
    { key: "remarks", title: "Remarks", dataIndex: "DocketText" }
  ];

  return (
    <Row gutter={[16, 16]}>
      {configurations.ctTRCRDocketTxt && messageVisible && (
        <Col xl={23} lg={23} md={23} sm={23} xs={23}>
          <Card>
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "end" }}>
              <FontAwesomeIcon icon={"times"} onClick={() => setMessageVisible(false)} />
            </div>
            <br />
            <div dangerouslySetInnerHTML={{ __html: props.civilTab ? configurations.ctCVLDocketTxt : configurations.ctTRCRDocketTxt }} />
          </Card>
        </Col>
      )}
      <Col xl={23} lg={23} md={23} sm={23} xs={23}>
        <BannerCard title="Docket">
          <Table dataSource={props.civilTab ? civilMaster?.docket?.LIST : caseMaster?.docket?.LIST} columns={props.civilTab ? civilColumns : columns} size="small" scroll={{ x: 720 }} />
        </BannerCard>
      </Col>
    </Row>

  );
};

export default CaseDocket;
